export default {
    // Header
    brand: 'PlayCatGames',
    nav: {
        home: 'Ana Sayfa',
        games: 'Oyunlar',
        categories: 'Kategoriler',
        about: 'Hakkında'
    },
    search: {
        placeholder: 'Kedi oyunlarını ara...'
    },

    // Hero Section
    hero: {
        title: 'Kedi Oyunları',
        description: 'PlayCatGames\'teki kedi oyunları, sanal kedilerle oynamanıza, onlarla ilgilenmenize ve her türlü eğlenceli ve zekice yollarla etkileşim kurmanıza olanak tanır. Ekrana oyuncaklar fırlatabilir, karakterin üzerine kıyafetleri sürükleyip bırakabilir veya balık yakalamak ve ödüllerin peşinden koşmak için hızlı refleksler kullanabilirsiniz.',
        subtitle: 'Bazı kedi oyunları zıplarken, koşarken veya tırmanırken zamanlamayı test ederken, diğerleri besleme, tımar etme veya puan kazanmak için dokunma gibi basit eylemlere odaklanır. Her başlık tarayıcınızda anında eğlence için tasarlanmıştır. Kurulum yok, indirme yok, sadece miyav!',
        buttons: {
            start: 'Oynamaya Başla',
            browse: 'Kategorilere Gözat'
        },
        stats: {
            games: 'Ücretsiz Oyunlar',
            categories: 'Oyun Kategorileri',
            free: 'Ücretsiz Deneyim',
            available: 'Her Zaman Mevcut'
        }
    },

    // Games Section
    games: {
        title: 'Popüler Kedi Oyunları',
        subtitle: 'Her yaştan oyuncu için en popüler ücretsiz çevrimiçi kedi oyunlarını keşfedin',
        filters: {
            all: 'Tümü',
            dressUp: 'Giydirme',
            care: 'Bakım',
            puzzle: 'Bulmaca',
            arcade: 'Arkad',
            simulation: 'Simülasyon'
        },
        loadMore: 'Daha Fazla Oyun Yükle',
        gameCategories: {
            arcade: 'Arkad',
            simulation: 'Simülasyon',
            care: 'Bakım',
            puzzle: 'Bulmaca',
            dressUp: 'Giydirme'
        }
    },

    // Categories Section
    categories: {
        title: 'Oyun Kategorileri',
        subtitle: 'Her kedi oyunu, oyuncuların en çok keyif aldığı aktiviteler etrafında inşa edilmiştir: stil verme, hayvan bakımı veya eğlenceli rotalar boyunca koşma',
        browse: 'Kategoriyi Gözat',
        featuredGames: 'Öne Çıkan Oyunlar',
        gameCount: 'Oyun',
        types: {
            dressUp: {
                name: 'Kedi Giydirme Oyunları',
                description: 'Kedi giydirme oyunları yaratıcılığınızı serbest bırakır. Kıyafetleri karıştırın, aksesuarlar ekleyin ve fantezi setlerinden mevsimlik ekipmanlara kadar temalı görünümlerin kilidini açın.'
            },
            simulation: {
                name: 'Kedi Simülasyonu ve Rol Yapma',
                description: 'Simülatör oyunlarında bir kedinin pençelerine adım atarsınız. Dolaşın, keşfedin ve meraklı bir kedinin yaşamını yaşayın.'
            },
            puzzle: {
                name: 'Kedi Yönetimi ve Bulmaca Oyunları',
                description: 'Strateji hayranları için kedi bulmaca ve yönetim oyunları zekice dönüşler sunar. Birden fazla kedinin dengesini kurun, zor yığma zorluklarını çözün.'
            },
            arcade: {
                name: 'Kedi Arkad ve Aksiyon Oyunları',
                description: 'Reflekslerinizi ve çevikliğinizi test eden hızlı tempolu kedi arkad oyunları. Zıplayın, koşun, yakalayın ve heyecan verici oyun deneyimlerinin tadını çıkarın.'
            }
        },
        additional: {
            title: 'Daha Fazla Kedi Oyunu Türünü Keşfedin',
            description: 'Kedi oyunu koleksiyonumuz her ruh halini ve tercihi kapsar: moda oyunu, evcil hayvan bakımı, zor bulmacalar veya eğlenceli arkad koşuları. Tarayıcı tabanlı kedi oyunlarımız ücretsiz, güvenli ve saniyeler içinde oynanmaya hazırdır.',
            motto: 'Sadece bir oyun seçin, başlata dokunun ve eğlencenin miyavlamasına izin verin!'
        }
    },

    // About Section
    about: {
        title: 'PlayCatGames Hakkında',
        description: [
            'PlayCatGames, kedi oyunlarının harika dünyasını keşfetmek için nihai hedefinizdir. Her yaştan oyuncu için uygun ücretsiz çevrimiçi kedi temalı oyunlar koleksiyonunu özenle seçtik.',
            'Sevimli giydirme oyunlarından heyecan verici arkad maceralarına, sıcak bakım simülasyonlarından zekice bulmaca zorluklarına kadar, oyun koleksiyonumuz kedi severlerin isteyebileceği her şeyi kapsar. Tüm oyunlar en iyi oyun deneyimini sağlamak için dikkatle seçilmiştir.',
            'Oyunların anında, eğlenceli ve kolay erişilebilir olması gerektiğine inanıyoruz. Bu yüzden tüm oyunlarımız herhangi bir yazılım indirmeden veya kurmadan doğrudan tarayıcınızda çalışabilir. Sadece tıklayın ve oynamaya başlayın!'
        ],
        features: {
            free: '%100 Ücretsiz Oyunlar',
            mobile: 'Mobil Dostu',
            instant: 'Anında Oynat',
            safe: 'Güvenli ve Emniyetli'
        },
        faq: {
            title: 'Sıkça Sorulan Sorular',
            questions: {
                free: {
                    q: 'Bu oyunlar gerçekten ücretsiz mi?',
                    a: 'Evet! Tüm kedi oyunlarımız tamamen ücretsizdir. Tüm oyun içeriğinin tadını çıkarmak için hiçbir şey ödemenize gerek yoktur.'
                },
                download: {
                    q: 'Herhangi bir yazılım indirmem gerekiyor mu?',
                    a: 'Hayır! Tüm oyunlar doğrudan tarayıcınızda çalışabilir. Oynamaya başlamak için sadece bir oyuna tıklayın, indirme veya kurulum gerekmez.'
                },
                age: {
                    q: 'Bu oyunlar hangi yaş grubu için uygun?',
                    a: 'Kedi oyunlarımız her yaştan oyuncu için uygundur. Basit giydirme oyunlarından zorlu bulmaca oyunlarına kadar, herkes kendine uygun oyunlar bulabilir.'
                },
                mobile: {
                    q: 'Oyunlar mobil cihazları destekliyor mu?',
                    a: 'Evet! Tüm oyunlarımız PC, tablet ve telefonlarda mükemmel çalışacak şekilde optimize edilmiştir. Her zaman, her yerde oyun keyfini yaşayabilirsiniz.'
                },
                updates: {
                    q: 'Yeni oyunlar ekleyecek misiniz?',
                    a: 'Kesinlikle! Oyun kütüphanemizi düzenli olarak güncelliyoruz ve yeni ilginç kedi oyunları ekliyoruz. En son oyun içeriğini kontrol etmek için sık sık geri gelin.'
                }
            }
        }
    },

    // Footer
    footer: {
        description: 'Ücretsiz çevrimiçi kedi oyunları koleksiyonunuzun hedefi. Onlarca heyecan verici kedi temalı oyunu keşfedin, oynayın ve tadını çıkarın.',
        quickLinks: 'Hızlı Bağlantılar',
        gameCategories: 'Oyun Kategorileri',
        support: 'Destek',
        links: {
            popularGames: 'Popüler Oyunlar',
            latestGames: 'En Son Oyunlar',
            recommendedGames: 'Önerilen Oyunlar',
            faq: 'SSS',
            contact: 'Bize Ulaşın',
            feedback: 'Geri Bildirim',
            privacy: 'Gizlilik Politikası',
            terms: 'Hizmet Şartları',
            cookies: 'Çerez Politikası',
            sitemap: 'Site Haritası'
        },
        copyright: 'Tüm hakları saklıdır.',
        disclaimer: 'Tüm oyun içeriği yalnızca eğlence ve eğitim amaçları için internetten temin edilmiştir. Herhangi bir telif hakkı sorunu varsa lütfen bizimle iletişime geçin.',
        backToTop: 'Başa Dön',
        friendlyLinks: 'Dost Siteler'
    },

    // Game Data
    gameData: {
        descriptions: {
            kittyLovesBirds: 'Kedinin uçan kuşları yakalamasına yardım edin ve reaksiyon hızınızı gösterin',
            catPizza: 'Bir kedi pizza dükkanı işletin ve müşteriler için lezzetli pizzalar yapın',
            funnyKittyCare: 'Sevimli kedilere bakın, besleyin, yıkayın ve oynayın',
            catsDrop: 'Denge ve strateji becerilerinizi test eden kedi yığma oyunu',
            catpad: 'Sevimli kedi platform atlama oyunu',
            funnyKittyDressup: 'Çeşitli kıyafet ve aksesuarlarla sevimli kedileri giydirin',
            kittyCats: 'Birden fazla sevimli kediyle etkileşim kuran gündelik oyun',
            dualCat: 'İki kediyi aynı anda kontrol eden meydan okuma oyunu',
            funnyKittyHaircut: 'Kediler için modaya uygun saç stilleri tasarlayan güzellik oyunu',
            catCoffeeShop: 'Bir kedi kahvesi işletin ve lezzetli içecekler yapın'
        },
        categories: {
            puzzle: 'Bulmaca',
            simulation: 'Simülasyon',
            casual: 'Gündelik',
            action: 'Aksiyon',
            adventure: 'Macera',
            strategy: 'Strateji',
            sports: 'Spor',
            racing: 'Yarış',
            dressup: 'Giydirme',
            care: 'Bakım'
        },
        tags: {
            cute: 'Sevimli',
            anime: 'Anime',
            dark: 'Karanlık',
            funny: 'Komik',
            educational: 'Eğitici',
            multiplayer: 'Çok Oyunculu',
            relaxing: 'Rahatlatıcı',
            challenging: 'Zorlu',
            colorful: 'Renkli',
            simple: 'Basit',
            complex: 'Karmaşık',
            family: 'Aile Dostu',
            kids: 'Çocuklar',
            adult: 'Yetişkin'
        }
    },

    // Common
    common: {
        loading: 'Yükleniyor...',
        error: 'Bir şeyler yanlış gitti',
        retry: 'Tekrar Dene',
        play: 'Oyunu Oyna',
        language: 'Dil',
        backToHome: 'Ana Sayfaya Dön'
    },

    // Legal Pages (simplified)
    legal: {
        privacy: { title: 'Gizlilik Politikası', lastUpdated: 'Son Güncelleme' },
        terms: { title: 'Hizmet Şartları', lastUpdated: 'Son Güncelleme' },
        cookies: { title: 'Çerez Politikası', lastUpdated: 'Son Güncelleme' }
    },

    // Sitemap
    sitemap: {
        title: 'Site Haritası',
        description: 'PlayCatGames web sitesindeki tüm sayfaları ve içerikleri bulun'
    }
}